var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChecklistIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00004 5.70714L5.35359 2.35359L4.64648 1.64648L2.00004 4.29293L0.853591 3.14648L0.146484 3.85359L2.00004 5.70714Z",
    fill: "#0072EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00004 9.70714L5.35359 6.35359L4.64648 5.64648L2.00004 8.29293L0.853591 7.14648L0.146484 7.85359L2.00004 9.70714Z",
    fill: "#0072EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4H6V3H11V4Z",
    fill: "#0072EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H11V7H6V8Z",
    fill: "#0072EF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChecklistIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checklist-icon.5bb2506af0a6d7645ab1f20b2574ffb4.svg";